module.exports = __webpack_public_path__ + "img/email.7a2e7622.svg";